import { render, staticRenderFns } from "./newhome.vue?vue&type=template&id=5ae83d84&scoped=true"
import script from "./newhome.vue?vue&type=script&lang=js"
export * from "./newhome.vue?vue&type=script&lang=js"
import style0 from "./newhome.vue?vue&type=style&index=0&id=5ae83d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae83d84",
  null
  
)

export default component.exports